var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00188 8.82114C7.1112 8.82114 8.82114 7.1112 8.82114 5.00188C8.82114 2.89256 7.1112 1.18262 5.00188 1.18262C2.89256 1.18262 1.18262 2.89256 1.18262 5.00188C1.18262 7.1112 2.89256 8.82114 5.00188 8.82114Z",
    stroke: "#8B8B8B",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.87048 2.93896V5.00195L6.10827 6.45517",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.87048 2.93896V5.00195L6.10827 6.45517",
    stroke: "#8B8B8B",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/iconClock.1095ae85dce96287abef7c52eca3f248.svg";
export { ForwardRef as ReactComponent };